module.exports = __webpack_public_path__ + "static/media/icon.328cea88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivitySelect/icon.svg
// module id = 304
// module chunks = 0